import { en, StringsShape } from "./strings.en";
import { es } from "./strings.es";
import { AppLocale, browserLanguage, resolveAppLocale } from "../utils/locale";

/**
 * The locale for static UI strings, resolved ONCE at module load (the browser
 * language cannot change mid-session without a reload). Consumers that need
 * locale-aware formatting (dates, Amplify I18n) read this instead of
 * navigator.language so their language always agrees with the UI strings.
 *
 * Testing note: because resolution happens at import time, tests exercise the
 * Spanish path by asserting `strings.es.ts` directly and unit-testing
 * `resolveAppLocale()` in isolation — not by mocking navigator.language after
 * this module is cached.
 */
export const activeLocale: AppLocale = resolveAppLocale();

export const strings: StringsShape = activeLocale === "es" ? es : en;

/**
 * Locale for Intl date/time FORMATTING (not text). Spanish when the UI is
 * Spanish; otherwise the browser's own regional locale, so en-GB/en-AU users
 * keep their 31/07 and 24-hour conventions exactly as before this feature.
 * Use this at call sites that historically passed no locale; call sites that
 * always hardcoded US English use activeLocale instead.
 */
export const dateLocale: string =
  activeLocale === "es" ? "es" : browserLanguage();
